import React from 'react';
import BookCover from './BookCover';
import { FiCheck, FiDownload, FiStar } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Hero = () => {
  return (
    <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 overflow-hidden">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-20">
          
          <div className="flex-1 text-center md:text-left z-10">
            <div className="inline-block bg-brand-yellow/10 text-brand-yellow px-4 py-1 rounded-full text-sm font-bold mb-6 border border-brand-yellow/20">
              New Release • Instant Download
            </div>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
              Stop Guessing <br/>
              <span className="text-brand-yellow">What They Mean</span>
            </h1>
            <p className="text-gray-300 text-lg md:text-xl mb-8 leading-relaxed max-w-2xl">
              The Translation Table decodes 100 relationship phrases—so you finally understand "I'm fine," "we need to talk," and every confusing moment in between.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start mb-8">
              <a 
                href="https://link.nordiccrm.ca/payment-link/69ab87521e61210f3f78bc8a" 
                target="_blank"
                rel="noopener noreferrer"
                className="bg-brand-yellow text-brand-black font-bold text-lg py-4 px-8 rounded-lg hover:bg-white transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(255,214,49,0.3)] flex items-center justify-center gap-2"
              >
                GET THE BOOK — $9.99 <SafeIcon icon={FiDownload} />
              </a>
            </div>

            <div className="flex flex-wrap justify-center md:justify-start gap-4 text-sm text-gray-400">
              <span className="flex items-center gap-1"><SafeIcon icon={FiCheck} className="text-brand-yellow" /> 500+ readers</span>
              <span className="flex items-center gap-1"><SafeIcon icon={FiStar} className="text-brand-yellow" /> 4.9★ rating</span>
              <span className="flex items-center gap-1"><SafeIcon icon={FiCheck} className="text-brand-yellow" /> 30-day guarantee</span>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md md:max-w-full">
            <BookCover />
            <p className="text-center text-gray-500 text-sm mt-8">
              100 Translations • 150 Pages • PDF + EPUB
            </p>
          </div>

        </div>
      </div>
      
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-brand-gray/20 to-transparent -z-10"></div>
    </section>
  );
};

export default Hero;